import React from "react";
import "./About.css";
import { Link } from "react-router-dom";
import about_left from "../../assets/about_vector.png";
import about_anime from "../../assets/about_anime.gif";
import linkden from "../../assets/li.png";
import instagram from "../../assets/in.png";
import Intro from "../Intro/Intro"
import HackerEarth from "../../assets/HE.png"

export default function About(props) {
    return <div className="about-container">
        <Intro header={"About Me"} content={"Sr. Software Engineer | Full Stack Developer | Airtel X Labs | Delhi University Alumni | Continuous Learner "}/>
        <div className="background">
            <div className="images">
            <img src={about_left}/>
            <img src={about_anime}/>
            </div>
        </div>
        <div className="about-me">

            <h3>About me</h3>
            <p> A Computer Science gradudate with 4+ year of experince in backend development and have worked on UI related technolgies as well. I have good understanding of Data Structure and Algorithm along with strong computer science fundamental. Till now I have worked in an aglie environment and have taken end to end responsiblity, i.e. from solutioning to deployment. I have listed my skills <Link className="link" to="/skills">here</Link></p>
            <h3>Learner</h3>
            <p>I am continous Learner with keen interest in technolgies. In free time i explore new technolgies in order to widen my technical understanding. I prefer working in a place that provide challenging environment where i can grow professionally , contribute to best of my capacity and grow during the process. </p>


            <div className="contact">
            <h3> I can be contacted on following handles </h3>

                <a href="https://www.linkedin.com/in/prashank-jauhari-368b58a6/"><img  className="skill-style" src={linkden}></img></a>
                <a href="https://www.instagram.com/prashank_jauhari/"><img className="skill-style" src={instagram}></img></a>
                <a href="https://www.hackerearth.com/@prashank.jauhari.16"><img className="skill-style" src={HackerEarth}></img></a>
                <h4>You can write to me on <i>prashank.jauhari@gmail.com</i></h4>
            </div>
        </div>

    </div>
}